import {del, post, put} from "../util/http.service";

export const createMileageLog = mileageLog => post("/mileage-logs", mileageLog);

export const updateMileageLog = (id, mileageLog) => put("/mileage-logs/" + id, mileageLog);

export const deleteMileageLog = id => del("/mileage-logs/" + id);
